// extracted by mini-css-extract-plugin
export var container = "_du-0";
export var infoIcon = "_du-2";
export var internalLabel = "_du-3";
export var titleRowCol = "_du-1";